;(function() {

    !function (t, e) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.ES6Promise = e()
    }(this, function () {
        "use strict";

        function t(t) {
            var e = typeof t;
            return null !== t && ("object" === e || "function" === e)
        }

        function e(t) {
            return "function" == typeof t
        }

        function n(t) {
            B = t
        }

        function r(t) {
            G = t
        }

        function o() {
            return function () {
                return process.nextTick(a)
            }
        }

        function i() {
            return "undefined" != typeof z ? function () {
                z(a)
            } : c()
        }

        function s() {
            var t = 0, e = new J(a), n = document.createTextNode("");
            return e.observe(n, {characterData: !0}), function () {
                n.data = t = ++t % 2
            }
        }

        function u() {
            var t = new MessageChannel;
            return t.port1.onmessage = a, function () {
                return t.port2.postMessage(0)
            }
        }

        function c() {
            var t = setTimeout;
            return function () {
                return t(a, 1)
            }
        }

        function a() {
            for (var t = 0; t < W; t += 2) {
                var e = V[t], n = V[t + 1];
                e(n), V[t] = void 0, V[t + 1] = void 0
            }
            W = 0
        }

        function f() {
            try {
                var t = Function("return this")().require("vertx");
                return z = t.runOnLoop || t.runOnContext, i()
            } catch (e) {
                return c()
            }
        }

        function l(t, e) {
            var n = this, r = new this.constructor(p);
            void 0 === r[Z] && O(r);
            var o = n._state;
            if (o) {
                var i = arguments[o - 1];
                G(function () {
                    return P(o, r, i, n._result)
                })
            } else E(n, r, t, e);
            return r
        }

        function h(t) {
            var e = this;
            if (t && "object" == typeof t && t.constructor === e) return t;
            var n = new e(p);
            return g(n, t), n
        }

        function p() {
        }

        function v() {
            return new TypeError("You cannot resolve a promise with itself")
        }

        function d() {
            return new TypeError("A promises callback cannot return that same promise.")
        }

        function _(t) {
            try {
                return t.then
            } catch (e) {
                return nt.error = e, nt
            }
        }

        function y(t, e, n, r) {
            try {
                t.call(e, n, r)
            } catch (o) {
                return o
            }
        }

        function m(t, e, n) {
            G(function (t) {
                var r = !1, o = y(n, e, function (n) {
                    r || (r = !0, e !== n ? g(t, n) : S(t, n))
                }, function (e) {
                    r || (r = !0, j(t, e))
                }, "Settle: " + (t._label || " unknown promise"));
                !r && o && (r = !0, j(t, o))
            }, t)
        }

        function b(t, e) {
            e._state === tt ? S(t, e._result) : e._state === et ? j(t, e._result) : E(e, void 0, function (e) {
                return g(t, e)
            }, function (e) {
                return j(t, e)
            })
        }

        function w(t, n, r) {
            n.constructor === t.constructor && r === l && n.constructor.resolve === h ? b(t, n) : r === nt ? (j(t, nt.error), nt.error = null) : void 0 === r ? S(t, n) : e(r) ? m(t, n, r) : S(t, n)
        }

        function g(e, n) {
            e === n ? j(e, v()) : t(n) ? w(e, n, _(n)) : S(e, n)
        }

        function A(t) {
            t._onerror && t._onerror(t._result), T(t)
        }

        function S(t, e) {
            t._state === $ && (t._result = e, t._state = tt, 0 !== t._subscribers.length && G(T, t))
        }

        function j(t, e) {
            t._state === $ && (t._state = et, t._result = e, G(A, t))
        }

        function E(t, e, n, r) {
            var o = t._subscribers, i = o.length;
            t._onerror = null, o[i] = e, o[i + tt] = n, o[i + et] = r, 0 === i && t._state && G(T, t)
        }

        function T(t) {
            var e = t._subscribers, n = t._state;
            if (0 !== e.length) {
                for (var r = void 0, o = void 0, i = t._result, s = 0; s < e.length; s += 3) r = e[s], o = e[s + n], r ? P(n, r, o, i) : o(i);
                t._subscribers.length = 0
            }
        }

        function M(t, e) {
            try {
                return t(e)
            } catch (n) {
                return nt.error = n, nt
            }
        }

        function P(t, n, r, o) {
            var i = e(r), s = void 0, u = void 0, c = void 0, a = void 0;
            if (i) {
                if (s = M(r, o), s === nt ? (a = !0, u = s.error, s.error = null) : c = !0, n === s) return void j(n, d())
            } else s = o, c = !0;
            n._state !== $ || (i && c ? g(n, s) : a ? j(n, u) : t === tt ? S(n, s) : t === et && j(n, s))
        }

        function x(t, e) {
            try {
                e(function (e) {
                    g(t, e)
                }, function (e) {
                    j(t, e)
                })
            } catch (n) {
                j(t, n)
            }
        }

        function C() {
            return rt++
        }

        function O(t) {
            t[Z] = rt++, t._state = void 0, t._result = void 0, t._subscribers = []
        }

        function k() {
            return new Error("Array Methods must be provided an Array")
        }

        function F(t) {
            return new ot(this, t).promise
        }

        function Y(t) {
            var e = this;
            return new e(U(t) ? function (n, r) {
                for (var o = t.length, i = 0; i < o; i++) e.resolve(t[i]).then(n, r)
            } : function (t, e) {
                return e(new TypeError("You must pass an array to race."))
            })
        }

        function q(t) {
            var e = this, n = new e(p);
            return j(n, t), n
        }

        function D() {
            throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")
        }

        function K() {
            throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")
        }

        function L() {
            var t = void 0;
            if ("undefined" != typeof global) t = global; else if ("undefined" != typeof self) t = self; else try {
                t = Function("return this")()
            } catch (e) {
                throw new Error("polyfill failed because global object is unavailable in this environment")
            }
            var n = t.Promise;
            if (n) {
                var r = null;
                try {
                    r = Object.prototype.toString.call(n.resolve())
                } catch (e) {
                }
                if ("[object Promise]" === r && !n.cast) return
            }
            t.Promise = it
        }

        var N = void 0;
        N = Array.isArray ? Array.isArray : function (t) {
            return "[object Array]" === Object.prototype.toString.call(t)
        };
        var U = N, W = 0, z = void 0, B = void 0, G = function (t, e) {
                V[W] = t, V[W + 1] = e, W += 2, 2 === W && (B ? B(a) : X())
            }, H = "undefined" != typeof window ? window : void 0, I = H || {},
            J = I.MutationObserver || I.WebKitMutationObserver,
            Q = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
            R = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel,
            V = new Array(1e3), X = void 0;
        X = Q ? o() : J ? s() : R ? u() : void 0 === H && "function" == typeof require ? f() : c();
        var Z = Math.random().toString(36).substring(2), $ = void 0, tt = 1, et = 2, nt = {error: null}, rt = 0,
            ot = function () {
                function t(t, e) {
                    this._instanceConstructor = t, this.promise = new t(p), this.promise[Z] || O(this.promise), U(e) ? (this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? S(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(e), 0 === this._remaining && S(this.promise, this._result))) : j(this.promise, k())
                }

                return t.prototype._enumerate = function (t) {
                    for (var e = 0; this._state === $ && e < t.length; e++) this._eachEntry(t[e], e)
                }, t.prototype._eachEntry = function (t, e) {
                    var n = this._instanceConstructor, r = n.resolve;
                    if (r === h) {
                        var o = _(t);
                        if (o === l && t._state !== $) this._settledAt(t._state, e, t._result); else if ("function" != typeof o) this._remaining--, this._result[e] = t; else if (n === it) {
                            var i = new n(p);
                            w(i, t, o), this._willSettleAt(i, e)
                        } else this._willSettleAt(new n(function (e) {
                            return e(t)
                        }), e)
                    } else this._willSettleAt(r(t), e)
                }, t.prototype._settledAt = function (t, e, n) {
                    var r = this.promise;
                    r._state === $ && (this._remaining--, t === et ? j(r, n) : this._result[e] = n), 0 === this._remaining && S(r, this._result)
                }, t.prototype._willSettleAt = function (t, e) {
                    var n = this;
                    E(t, void 0, function (t) {
                        return n._settledAt(tt, e, t)
                    }, function (t) {
                        return n._settledAt(et, e, t)
                    })
                }, t
            }(), it = function () {
                function t(e) {
                    this[Z] = C(), this._result = this._state = void 0, this._subscribers = [], p !== e && ("function" != typeof e && D(), this instanceof t ? x(this, e) : K())
                }

                return t.prototype["catch"] = function (t) {
                    return this.then(null, t)
                }, t.prototype["finally"] = function (t) {
                    var e = this, n = e.constructor;
                    return e.then(function (e) {
                        return n.resolve(t()).then(function () {
                            return e
                        })
                    }, function (e) {
                        return n.resolve(t()).then(function () {
                            throw e
                        })
                    })
                }, t
            }();
        return it.prototype.then = l, it.all = F, it.race = Y, it.resolve = h, it.reject = q, it._setScheduler = n, it._setAsap = r, it._asap = G, it.polyfill = L, it.Promise = it, it
    });

    window.Promise = ES6Promise;

    'use strict';

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();


    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var fileSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;

    var ReadFile = function () {
        // fileReader实例
        // frInstance = '';
        // 文件句柄
        // fileObj = '';

        function ReadFile(fileObj) {
            _classCallCheck(this, ReadFile);

            this.frInstance = new FileReader();
            this.fileObj = fileObj;
            this.read = this.read.bind(this);
        }

        _createClass(ReadFile, [{
            key: 'read',
            value: function read(s, e) {
                this.frInstance.onloadstart = this.onloadstart.bind(this);
                this.frInstance.onload = this.onload;
                this.frInstance.onloadend = this.onloadend.bind(this);
                this.frInstance.onprogress = this.onprogress.bind(this);
                this.frInstance.onerror = this.onerror.bind(this);
                var fileObj = this.fileObj;
                if (!fileObj) {
                    console.error('ReadFile do not have fileObj');
                    return false;
                }
                var limitS = s || 0;
                var limitE = e || fileObj.size;
                var blobTmp = fileSlice.call(fileObj, s, e);
                this.frInstance.readAsArrayBuffer(blobTmp);
                return blobTmp;
            }
        }, {
            key: 'onloadstart',
            value: function onloadstart(e) {
            }
        }, {
            key: 'onprogress',
            value: function onprogress(e) {
            }
        }, {
            key: 'onload',
            value: function onload(e) {
            }
        }, {
            key: 'onerror',
            value: function onerror(e) {
            }
        }, {
            key: 'onloadend',
            value: function onloadend(e) {
            }
        }]);

        return ReadFile;
    }();

// option = {
//     srv: '', 服务器地址
//     params: {} ,  上传参数
// };
    var Upload = function () {
        // xhr = '';
        // srvUrl = '';
        // fobj = '';
        function Upload(option) {
            _classCallCheck(this, Upload);

            this.option = option;
            if (!option.srv) {
                console.error('send function error (no srv)');
                return false;
            }
            var argsTmp = Upload.getParam(option.params);
            var srvUrl = option.srv;
            if (argsTmp) {
                if (srvUrl.indexOf('?') < 0) {
                    srvUrl += '?' + argsTmp;
                } else {
                    srvUrl += '&' + argsTmp;
                }
            }
            this.srvUrl = srvUrl;
            var xhr = new window.XMLHttpRequest() || new window.ActiveXObject('Msxml2.XMLHTTP');
            var uploadEvent = xhr.upload;
            uploadEvent.addEventListener('loadstart', this.loadstart.bind(this));
            uploadEvent.addEventListener('progress', this.progress.bind(this));
            uploadEvent.addEventListener('load', this.load.bind(this));
            uploadEvent.addEventListener('abort', this.abort.bind(this));
            uploadEvent.addEventListener('error', this.error.bind(this));
            uploadEvent.addEventListener('timeout', this.timeout.bind(this));
            uploadEvent.addEventListener('loadend', this.loadend.bind(this));
            // 整个请求完成
            xhr.onreadystatechange = this.finish.bind(this);
            this.xhr = xhr;
        }

        _createClass(Upload, [{
            key: 'send',
            value: function send(fileTmp, otherParams) {
                if (!fileTmp) {
                    console.log('upload send nothing');
                    return;
                }
                this.fobj = fileTmp;
                var xhr = this.xhr;
                var srvUrlTmp = this.srvUrl;
                if (otherParams) {
                    var argsTmp = Upload.getParam(otherParams);
                    if (argsTmp) {
                        if (srvUrlTmp.indexOf('?') < 0) {
                            srvUrlTmp += '?' + argsTmp;
                        } else {
                            srvUrlTmp += '&' + argsTmp;
                        }
                    }
                }
                xhr.open('POST', srvUrlTmp);
                if (xhr.overrideMimeType) {
                    xhr.overrideMimeType('application/octet-stream');
                }
                var form = new FormData();
                form.append('file', fileTmp);
                xhr.send(form);
            }
        }, {
            key: 'abortFn',
            value: function abortFn() {
                this.xhr.abort();
            }
        }, {
            key: 'loadstartHandle',
            value: function loadstartHandle(fObj, e) {
            }
        }, {
            key: 'loadstart',
            value: function loadstart(e) {
                console.log('this is loadstart');
                this.fobj.status = 'loadstart';
                this.loadstartHandle(this.fobj, e);
            }
        }, {
            key: 'loadHandle',
            value: function loadHandle(fObj, e) {
            }
        }, {
            key: 'load',
            value: function load(e) {
                console.log('this is load');
                this.fobj.status = 'load';
                this.loadHandle(this.fobj, e);
            }
        }, {
            key: 'progressHandle',
            value: function progressHandle(fObj, e) {
            }
        }, {
            key: 'progress',
            value: function progress(e) {
                console.log('this is progress');
                var rateTmp = '';
                if (e.lengthComputable) {
                    rateTmp = e.loaded / e.total;
                }
                this.fobj.status = 'progress';
                this.fobj.rate = rateTmp;
                this.progressHandle(this.fobj, e);
            }
        }, {
            key: 'abortHandle',
            value: function abortHandle(fObj, e) {
            }
        }, {
            key: 'abort',
            value: function abort(e) {
                console.log('this is abort');
                this.fobj.status = 'abort';
                this.abortHandle(this.fobj, e);
            }
        }, {
            key: 'errorHandle',
            value: function errorHandle(fObj, err) {
            }
        }, {
            key: 'error',
            value: function error(e) {
                console.log('this is error');
                this.fobj.status = 'error';
                this.errorHandle(this.fobj);
            }
        }, {
            key: 'timeoutHandle',
            value: function timeoutHandle(fObj, e) {
            }
        }, {
            key: 'timeout',
            value: function timeout(e) {
                console.log('this is timeout');
                this.fobj.status = 'timeout';
                this.timeoutHandle(this.fobj, e);
            }
        }, {
            key: 'loadendHandle',
            value: function loadendHandle(fObj, e) {
            }
        }, {
            key: 'loadend',
            value: function loadend(e) {
                console.log('this is loadend');
                this.loadendHandle(this.fobj, e);
            }
        }, {
            key: 'finishHandle',
            value: function finishHandle(fObj, data) {
            }
        }, {
            key: 'finish',
            value: function finish() {
                var xhrTmp = this.xhr;
                if (xhrTmp.readyState === 4) {
                    var dataTmp = '';
                    try {
                        dataTmp = JSON.parse(xhrTmp.responseText);
                    } catch (e) {
                        dataTmp = xhrTmp.responseText;
                    }
                    if (+xhrTmp.status === 200) {
                        this.finishHandle(this.fobj, dataTmp);
                    } else {
                        this.errorHandle(this.fobj, dataTmp);
                    }
                }
            }
        }, {
            key: 'off',
            value: function off() {
                var self = this;
                var uploadEvent = this.xhr.upload;
                uploadEvent.removeEventListener('loadstart', this.loadstart.bind(self));
                uploadEvent.removeEventListener('progress', this.progress.bind(self));
                uploadEvent.removeEventListener('load', this.load.bind(self));
                uploadEvent.removeEventListener('abort', this.abort.bind(self));
                uploadEvent.removeEventListener('error', this.error.bind(self));
                uploadEvent.removeEventListener('timeout', this.timeout.bind(self));
                uploadEvent.removeEventListener('loadend', this.loadend.bind(self));
            }
        }], [{
            key: 'getParam',
            value: function getParam(objTmp) {
                var paramTmp = '';
                for (var k in objTmp) {
                    var headSymbol = paramTmp ? '&' : '';
                    if (k === 'name') {
                        paramTmp += '' + headSymbol + k + '=' + encodeURIComponent(objTmp[k]);
                    } else {
                        paramTmp += '' + headSymbol + k + '=' + objTmp[k];
                    }
                }
                return paramTmp;
            }
        }]);

        return Upload;
    }();

// option={
//     id: 目标id,
//     multiple: 是否可以上传多个
//     autoUpload: 是否自动上传
//     synNum: 同时可以上传的个数 p.s.默认1个
//     chunkSize:  0  当为大于0时，则以这个大小分片上传
//     uploadOption: {  上传文件的配置
//          srv: ''
//          params: {
//              md5: ''
//          }
//      }
//     sameCheck: fn( resolveFn, rejectFn )  文件上传前的检测， 用于秒传 没有则不进行检测，   调用resolveFn则进行上传， 调用rejectFn则不进行上传
//     sort: fn   // 排序 p.s. 排序的比较函数（通过对文件对象添加额外的）
//     onFilter: fn （[file]） // 选中的文件过滤
//     onProgress: fn   // 文件上传进度
//     onSuccess: fn
//     onError: fn
//     onAbort: fn
// }
// todo 可以将分块读取方法 加入到option中以便自己写针对性的读取方法
// 功能： 维持自己的上传队列，处理队列，只要发生错误就会被删除

    var uploadFactory = function () {
        // uploadQueue = [];
        function uploadFactory(option) {
            _classCallCheck(this, uploadFactory);

            // {status: waiting|uploading|end, fileObj: File|Blob, level: }
            this.uploadQueue = [];
            // 处理中的队列
            this.handleQueue = [];
            this.option = option;
            this.idx = 0;
            if (option.id) {
                create(option).addEventListener('change', this.start.bind(this));
            }
            this.find.bind(this);
            this.upload.bind(this);
            this.add.bind(this);
            this.abort.bind(this);
            this.del.bind(this);
            this.loadNext.bind(this);
            this.abortByKV.bind(this);
        }

        // read(s,e,readInstance){
        //     if(readInstance){
        //         this.userInstance.readObj = readInstance;
        //     } else{
        //         readInstance = this.userInstance.readObj;
        //     }
        //     return readInstance.read(s,e);
        // }


        _createClass(uploadFactory, [{
            key: 'find',
            value: function find(uploadInstance, arrTmp) {
                if (!uploadInstance) {
                    return;
                }
                var idx = uploadInstance.idx;
                arrTmp = arrTmp || this.uploadQueue;
                for (var i = 0; i < arrTmp.length; i++) {
                    if (idx === arrTmp[i].idx) {
                        return {
                            obj: arrTmp[i],
                            idx: i
                        };
                    }
                }
                return {
                    obj: '',
                    idx: -1
                };
            }
        }, {
            key: 'check',
            value: function check(fObj, subCb) {
                var self = this;

                function _onError (err) {
                    fObj.status = 'error';
                    
                    if (self.option.onError) {
                        self.option.onError(fObj, err);
                    }
                }

                var reader = new FileReader();
                reader.readAsDataURL(fObj);
                reader.onload = function(event) {
                    var img = new Image();
                    img.src = event.target.result;
                    img.onload = function() {
                        var _width = img.width;
                        var _height = img.height;
                        var _size = fObj.size;

                        // 国际站旧项目只有文件上传，后续如果要增加视频上传功能也是在新项目做，所以不用考虑视频上传
                        var uploadKey = self.option.uploadKey || 'default'

                        var _maxWidth = DSSX.util.safe(DSSX.APP_CONFIG, 'uploadConfig.image_limit.AlibabaOld.default.width', 0);
                        var _maxHeight = DSSX.util.safe(DSSX.APP_CONFIG, 'uploadConfig.image_limit.AlibabaOld.default.height', 0);
                        var _maxSize = DSSX.util.safe(DSSX.APP_CONFIG, 'uploadConfig.size_limit.AlibabaOld.default', 0);

                        var _maxWidth = DSSX.util.safe(DSSX.APP_CONFIG, 'uploadConfig.image_limit.AlibabaOld.' + uploadKey + '.width', _maxWidth);
                        var _maxHeight = DSSX.util.safe(DSSX.APP_CONFIG, 'uploadConfig.image_limit.AlibabaOld.' + uploadKey + '.height', _maxHeight);
                        var _maxSize = DSSX.util.safe(DSSX.APP_CONFIG, 'uploadConfig.size_limit.AlibabaOld' + uploadKey, _maxSize);

                        if(_width > _maxWidth || _height > _maxHeight) {
                            _onError({
                                type: 'UPLOAD_CHECK',
                                code: 100,
                                msg: '上传失败，请上传不大于' + _maxWidth + '*' + _maxHeight + '的图片',
                            });
                            return;
                        }

                        if(_size > _maxSize) {
                            _onError({
                                type: 'UPLOAD_CHECK',
                                code: 200,
                                msg: '上传失败，请上传不大于' + DSSX.util.fileSizeToStr(_maxSize) + '的图片',
                            });
                            return;
                        }

                        subCb && subCb();
                    }
                }
            }
        }, {
            key: 'upload',
            value: function upload(fObj, s) {
                if (!fObj) {
                    console.error('received bad args(null)');
                    return;
                }

                var _find = this.find(fObj),
                    curInstance = _find.obj;

                if (!curInstance) {
                    this.add([fObj]);
                    curInstance = this.find(fObj)['obj'];
                }
                if (curInstance.f.status === 'waiting') {
                    this.handleQueue.push(curInstance);
                }
                var sendF = fObj;
                var optionTmp = this.option;
                var self = this;
                if (optionTmp.chunkSize) {
                    optionTmp.readStart = s;
                    // 分片上传不需要处理loadend
                    curInstance.uploadObj.loadendHandle = function () {
                    };
                    checkUpload(curInstance).then(function (msg) {
                        return new Promise(function (resolve, reject) {
                            var judgeO = self.find(curInstance);
                            if (!judgeO || !judgeO.obj) {
                                return reject();
                            }
                            if (typeof optionTmp.sameCheck === 'function') {
                                msg.fObj = fObj;
                                optionTmp.sameCheck(msg, resolve, reject);
                            } else {
                                resolve();
                            }
                        });
                    }).then(function (other) {
                        return new Promise(function (resolve, reject) {
                            var judgeO = self.find(curInstance);
                            if (!judgeO || !judgeO.obj) {
                                return reject();
                            }
                            optionTmp.resolveTmp = resolve;
                            optionTmp.rejectTmp = reject;
                            chunkUpload(curInstance, optionTmp, other);
                        });
                    }).then(function () {
                        self.loadend(fObj);
                    }).catch(function (e) {
                        console.log(e);
                        self.loadend(fObj);
                    });
                    return;
                }
                curInstance.uploadObj.send(sendF);
            }
        }, {
            key: 'start',
            value: function start(e) {
                var curTargtet = e.target || e.srcElement;
                var files = curTargtet.files;
                var option = this.option;
                if (typeof option.onFilter === 'function') {
                    files = option.onFilter(files) || [];
                    if (!files.length) {
                        console.log('after start function (files is null)');
                    }
                }
                this.add(files);
            }
        }, {
            key: 'add',
            value: function add(files) {
                var option = this.option;
                for (var i = 0; i < files.length; i++) {
                    this.idx += 1;
                    var fTmp = files[i];
                    if (fTmp.status) {
                        console.warn('the file instance is in the queue');
                        continue;
                    }
                    fTmp.idx = this.idx;
                    fTmp.status = 'waiting';
                    var obj = {
                        idx: this.idx,
                        f: fTmp,
                        readObj: new ReadFile(fTmp),
                        uploadObj: new Upload(option.uploadOption),
                        workAdd: option.workAdd
                    };

                    obj.uploadObj.errorHandle = this.errorHandle.bind(this);
                    obj.uploadObj.progressHandle = this.progressHandle.bind(this);
                    obj.uploadObj.abortHandle = this.abortHandle.bind(this);
                    obj.uploadObj.finishHandle = this.finish.bind(this);
                    obj.uploadObj.loadendHandle = this.loadend.bind(this);
                    this.uploadQueue.push(obj);
                }
                if (option.autoUpload) {
                    this.loadNext();
                }
            }
        }, {
            key: 'loadNext',
            value: function loadNext() {
                console.log('this is loadNext function handled queue is: ', this.handleQueue);
                var self = this;
                var handleNum = this.handleQueue.length;
                var optionTmp = this.option;
                var sortFn = optionTmp.sort || '';
                if (typeof sortFn === 'function') {
                    this.uploadQueue.sort(sortFn);
                }
                for (var i = 0; i < this.uploadQueue.length; i++) {
                    var curFO = this.uploadQueue[i];
                    var fTmp = curFO.f;
                    if (fTmp.status === 'waiting' && (!handleNum || handleNum < optionTmp.synNum)) {
                        this.check(fTmp, function() {
                            self.upload(fTmp);
                        })
                    }
                }
            }
        }, {
            key: 'abort',
            value: function abort(uploadInstance) {
                if (!uploadInstance) {
                    console.error('received bad args (null)');
                    return;
                }

                var _find2 = this.find(uploadInstance),
                    curInstance = _find2.obj,
                    idx = _find2.idx;

                if (!curInstance) {
                    console.log('[error] not fount current uploadInstance in the queue', uploadInstance);
                    return;
                }
                curInstance.uploadObj.abortFn();
                for (var i = 0; i < this.handleQueue.length; i++) {
                    if (uploadInstance.idx === this.handleQueue[i].idx) {
                        this.handleQueue.splice(i, 1);
                        break;
                    }
                }
                curInstance.uploadObj.off();
                this.uploadQueue.splice(idx, 1);
            }
        }, {
            key: 'abortByKV',
            value: function abortByKV(key, value) {
                var hLen = this.handleQueue.length;
                var qLen = this.uploadQueue.length;
                var s = 0;
                while (s < hLen) {
                    if (s < hLen && getValue(this.handleQueue[s].f, key) === value) {
                        var o = this.handleQueue[s];
                        o.f.status = 'abort';
                        o.uploadObj.abortFn();
                        o.uploadObj.off();
                        this.handleQueue.splice(s, 1);
                        s -= 1;
                    }
                    s += 1;
                    hLen = this.handleQueue.length;
                }
                s = 0;
                while (s < qLen) {
                    if (s < qLen && getValue(this.uploadQueue[s].f, key) === value) {
                        this.uploadQueue.splice(s, 1);
                        s -= 1;
                    }
                    s += 1;
                    qLen = this.uploadQueue.length;
                }
            }
        }, {
            key: 'del',
            value: function del(uploadInstance) {
                var _find3 = this.find(uploadInstance),
                    curInstance = _find3.obj,
                    idx = _find3.idx;

                if (!curInstance) {
                    console.log('[error] not fount current uploadInstance in the queue', uploadInstance);
                    return;
                }
                if (uploadInstance.status === 'progress') {
                    this.abort(uploadInstance);
                    curInstance.uploadObj.abortFn();
                } else {
                    for (var i = 0; i < this.handleQueue.length; i++) {
                        if (uploadInstance.idx === this.handleQueue[i].idx) {
                            this.handleQueue.splice(i, 1);
                            break;
                        }
                    }
                }
                curInstance.uploadObj.off();
                this.uploadQueue.splice(idx, 1);
            }
        }, {
            key: 'finish',
            value: function finish(fObj, data) {
                var option = this.option;
                if (data.code === 0 && typeof option.onSuccess === 'function') {
                    option.onSuccess(fObj, data);
                } else if (data.code !== 0) {
                    this.errorHandle(fObj, data);
                }
            }
        }, {
            key: 'abortHandle',
            value: function abortHandle(fObj, e) {
                this.del(fObj);
                this.loadNext();
                if (this.option.onAbort) {
                    var _find4 = this.find(fObj),
                        curInstance = _find4.obj;

                    this.option.onAbort(curInstance.f, e);
                }
            }
        }, {
            key: 'errorHandle',
            value: function errorHandle(fObj, err) {
                this.del(fObj);
                this.loadNext();
                if (this.option.onError) {
                    var _find5 = this.find(fObj),
                        curInstance = _find5.obj;

                    this.option.onError(curInstance.f, err);
                }
            }
        }, {
            key: 'loadend',
            value: function loadend(fObj, e) {
                this.del(fObj);
                this.loadNext();
            }
        }, {
            key: 'progressHandle',
            value: function progressHandle(fObj, e) {
                console.log('this is progressHandle');

                var _find6 = this.find(fObj),
                    curInstance = _find6.obj;

                if (!curInstance) {
                    return;
                }
                if (this.option.onProgress) {
                    var fTmp = curInstance.f;
                    fTmp.uploadedSize = fTmp.uploadedSize || 0;
                    var rateTmp = (fTmp.uploadedSize + fObj.rate * fObj.size) / fTmp.size;
                    fTmp.rate = rateTmp;
                    this.option.onProgress(fTmp, e);
                }
            }
        }]);

        return uploadFactory;
    }();

    /**
     * 分块读取
     * @param readObj readFile 实例
     * @param startPos 开始读取的位置
     * @param chunkSize 读取的大小
     * @returns {Promise}
     */


    function chunkReader(readObj, startPos, chunkSize, workAdd) {
        return new Promise(function (resolve, reject) {
            var workerTmp = '';
            var partF = '';
            readObj.onload = function (e) {
                workerTmp = new Worker('/common/file-worker.js');
                var curTarget = e.target || e.srcElement;
                workerTmp.postMessage({
                    file: curTarget.result,
                    workAdd: workAdd
                });
                workerTmp.onmessage = function (msg) {
                    console.log('this is workerTmp event: ', msg);
                    resolve({fp: partF, e: msg.data, ft: readObj.fileObj});
                    workerTmp.terminate();
                };
            };
            readObj.onerror = function (e) {
                reject(e);
            };
            partF = readObj.read(startPos, startPos + chunkSize);
            partF.idx = readObj.fileObj.idx;
            if (!partF) {
                reject('can not find the read function');
            }
        });
    }

    function checkUpload(curInstance) {
        var chunkTmp = 1024 * 1024 * 2;
        var sizeTmp = curInstance.f.size;
        // return new Promise( (resolve, reject) => {
        //     function readAll(s, size){
        //         chunkReader(curInstance.readObj, 0, chunkTmp).then((data)=>{
        //             if(s >= sizeTmp){
        //                 resolve()
        //             } else {
        //                 readAll(s+size, size);
        //             }
        //         })
        //     }
        //     readAll(0, chunkTmp);
        // });
        return new Promise(function (resolve, reject) {
            try {
                var workerTmp = new Worker('/common/file-worker.js');
                workerTmp.postMessage({
                    file: curInstance.f,
                    chunk: {
                        s: 0,
                        chunkSize: chunkTmp
                    },
                    workAdd: curInstance.workAdd
                });
                workerTmp.onmessage = function (msg) {
                    console.log('this is workerTmp event: ', msg);
                    resolve(msg.data);
                    workerTmp.terminate();
                };
            } catch (e) {
                reject(e);
            }
        });
    }

    /**
     * 分块上传
     * @param obj upload factory 组装的实例
     * @param option
     */
    function chunkUpload(obj, option, other) {
        var chunkSize = option.chunkSize;
        option.readStart = other && other.readStart || option.readStart || 0;
        option.uploadId = other && other.uploadId || option.uploadId;
        var startPos = option.readStart || 0;
        var totalSize = obj.f.size;
        // 读取指定块的md5
        chunkReader(obj.readObj, startPos, chunkSize, obj.workAdd).then(function (data) {
            obj.uploadObj.finishHandle = function (fObj, dataTmp) {
                // fObj.readStart = data.fp.size;
                if (dataTmp.code !== 0 || obj.errNum > 10) {
                    if (obj.errNum > 10) {
                        console.error('读取片数超过10次');
                    }
                    if (typeof option.onError === 'function') {
                        option.onError(obj.f, dataTmp);
                    }
                    return option.resolveTmp();
                } else if (option.readStart + chunkSize < totalSize) {
                    var sTmp = getValue(dataTmp, 'data.detail.index') || 0;
                    // 读取重复片数限制
                    if (option.readStart === sTmp) {
                        obj.errNum = (obj.errNum || 0) + 1;
                    } else {
                        obj.errNum = 0;
                    }
                    obj.f.uploadedSize = sTmp;
                    option.readStart = sTmp;
                    chunkUpload(obj, option);
                } else {
                    if (typeof option.onSuccess === 'function') {
                        option.onSuccess(obj.f, dataTmp);
                    }
                    return option.resolveTmp();
                }
            };
            if (obj.f.status === 'abort') {
                return;
            }
            var leftChunk = totalSize - option.readStart;
            var optionTmp = {
                md5: data.e.md5,
                name: obj.f.name,
                length: leftChunk >= chunkSize ? chunkSize : leftChunk,
                index: option.readStart,
                uploadId: option.uploadId
            };
            obj.f.readSize = optionTmp.index + optionTmp.length;
            obj.uploadObj.send(data.fp, optionTmp);
        }, function (err) {
            console.error('uploadfactory upload error: ', err);
            return option.resolveTmp();
        });
    }

    /**
     * 创建input上传选择
     * @param {*} option
     */
    function create(option) {
        if (!option.id) {
            console.error('create received bad arg(id not existed)', option);
            return;
        }
        var childDom = document.createElement('input');
        childDom.type = 'file';
        // childDom.setAttribute('style', 'display: none');
        option.multi && (childDom['multiple'] = '');
        document.getElementById(option.id).appendChild(childDom);
        return childDom;
    }

    function getValue(obj, key) {
        var keyArr = key.split('.');
        for (var i = 0; i < keyArr.length; i++) {
            if (!obj) {
                return NaN;
            }
            obj = obj[keyArr[i]] || '';
        }
        return obj;
    }

    window.uploadFactory = uploadFactory;
// exports.default = uploadFactory;
})();